module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-amap', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "amap-demo",
    attrs: {
      "vid": "amap",
      "zoom": _vm.zoom,
      "center": _vm.center
    }
  }, [_c('el-amap-polyline', {
    attrs: {
      "editable": _vm.polyline.editable,
      "path": _vm.polyline.path,
      "events": _vm.polyline.events
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27eb2ce4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/meterReading/Track/TrackMap.vue
// module id = 1724
// module chunks = 1